import axios from 'axios';
import { API_BASE_URL, env } from '@/env';

/**
 * Paylasilan axios ornegi. Koken bos ise ayni kokene gider (nginx / vite proxy
 * /api'yi gateway'e tasir) — bu yuzden burada mutlak adres kurulmaz.
 *
 * Oturum/yetki kesicileri (interceptor) 2. fazda eklenecek; iskelette yalniz
 * taban yapilandirma var.
 */
export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20_000,
  headers: {
    'Content-Type': 'application/json',
    'X-Client': `kural-app/${env.VITE_APP_VERSION}`,
  },
});
